import { render, staticRenderFns } from "./CountersNewValueForm.vue?vue&type=template&id=2ce4bf21&"
import script from "./CountersNewValueForm.vue?vue&type=script&lang=ts&"
export * from "./CountersNewValueForm.vue?vue&type=script&lang=ts&"
import style0 from "./CountersNewValueForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRow,VTextField})
